var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8 is-offset-2"},[(
              _vm.preinscription.data.formulaire
                .licencePreinscriptionFormulaireEtape.numeroEtape === 2
            )?_c('MutationPreinscription',{attrs:{"preinscription":_vm.preinscription,"token":_vm.token}}):_vm._e(),(
              _vm.preinscription.data.formulaire
                .licencePreinscriptionFormulaireEtape.numeroEtape === 9 &&
                _vm.preinscription.data.statut === 'AE'
            )?_c('GestionASTTPreinscription',{attrs:{"preinscription":_vm.preinscription,"token":_vm.token}}):_vm._e(),(
              _vm.preinscription.data.formulaire
                .licencePreinscriptionFormulaireEtape.numeroEtape > 2 &&
                _vm.preinscription.data.formulaire
                  .licencePreinscriptionFormulaireEtape.numeroEtape < 9
            )?_c('horizontal-stepper',{attrs:{"steps":_vm.demoSteps,"preinscription":_vm.preinscription,"token":_vm.token},on:{"completed-step":_vm.completeStep,"active-step":_vm.isStepActive,"stepper-finished":_vm.alert}}):_vm._e(),(
              _vm.preinscription.data.formulaire.validation === '111111110' &&
                _vm.preinscription.data.statut !== 'AE'
            )?_c('RemerciementsPreinscription',{attrs:{"token":_vm.token}}):_vm._e(),(_vm.preinscription.data.formulaire.validation === '111111111')?_c('RemerciementsPreinscriptionASTT'):_vm._e()],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }